module.exports = __webpack_public_path__ + "img/view-tablet.788f60e5.png";